import { render, staticRenderFns } from "./AdminRouteTask.vue?vue&type=template&id=694b9c48&scoped=true"
import script from "./AdminRouteTask.vue?vue&type=script&lang=js"
export * from "./AdminRouteTask.vue?vue&type=script&lang=js"
import style0 from "./AdminRouteTask.vue?vue&type=style&index=0&id=694b9c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694b9c48",
  null
  
)

export default component.exports